module.exports = __webpack_public_path__ + "static/media/administration_vendors.ab1bd3ca.svg";